module.exports = __webpack_public_path__ + "img/_PWK2552_-PSedit_.b8602174.jpeg";